import { Link } from "react-router-dom";
import { FlexRow, FlexColumn } from "~/shared/components/flexes";
import {
  Headline6,
  MediumText,
  SmallText,
} from "~/shared/components/typography";
import { calculateTimePassed } from "~/shared/utils/time";
import styled from "styled-components";

import type { PostShape } from "./types";

const Wrapper = styled(FlexColumn)`
  gap: 10px;
`;

const TitleWrapper = styled(FlexColumn)`
  gap: 5px;
`;

const Title = styled(Headline6)`
  color: var(--primary-4);
`;

const Date = styled(SmallText)`
  font-weight: 400;
  font-family: fantasy;
  color: #0d0e17;
`;

const Excerpt = styled(MediumText)`
  color: #0d0e17;
`;

const PostItem = ({
  id,
  title,
  authorName,
  role,
  createdAt,
  excerpt,
}: PostShape) => {
  return (
    <Link to={`/posts/${id}`}>
      <Wrapper>
        <TitleWrapper>
          <FlexRow>
            <Title>{title}</Title>
          </FlexRow>

          <Date>
            <strong>
              {authorName}, {role}
            </strong>
            {"  "} <span>| {calculateTimePassed(createdAt)}</span>
          </Date>
        </TitleWrapper>

        <Excerpt>{excerpt}</Excerpt>
      </Wrapper>
    </Link>
  );
};

export default PostItem;
